import { ChangeEvent, SyntheticEvent } from 'react';
import { logger } from 'logging-utils';
import ConnectionsConfigureStore from '../stores/connection-configure-store';
import {
  Connection,
  ConnectionFormFields,
  ConnectionInputField,
} from '../types/connection-types';

export const toggleSwitch = (
  _: SyntheticEvent<Element, Event>,
  checked: boolean,
): void => {
  setUseCommonEndpointInput(checked);

  setIsModalUpdatable(true);
};

export const setTextField = (event: ChangeEvent<HTMLInputElement>): void => {
  const { name, value } = event.target;

  switch (name) {
    case ConnectionInputField.domain:
      setDomainInput(value);
      break;
    case ConnectionInputField.clientId:
      setClientIdInput(value);
      break;
    case ConnectionInputField.clientSecret:
      setClientSecretInput(value);
      break;
    default:
      logger.warn('Tried to update an unknown connection field name');
      break;
  }

  setIsModalUpdatable(true);
};

const setDomainInput = (value: string) => {
  ConnectionsConfigureStore.domain = value;
};

const setClientIdInput = (value: string) => {
  ConnectionsConfigureStore.clientId = value;
};

const setClientSecretInput = (value: string) => {
  ConnectionsConfigureStore.clientSecret = value;
};

const setUseCommonEndpointInput = (value: boolean) => {
  ConnectionsConfigureStore.useCommonEndpoint = value;
};

const setIsModalUpdatable = (value: boolean) => {
  ConnectionsConfigureStore.isUpdatable = value;
};

export const setInitialFormValues = (selectedConnection: Connection) => {
  if (!selectedConnection || !selectedConnection.isSetupRequired) {
    return;
  }

  const initialValues = getFormValues(selectedConnection);
  setFormValues(initialValues);
};

export const resetForm = () => {
  setDomainInput('');
  setClientIdInput('');
  setClientSecretInput('');
  setUseCommonEndpointInput(true);
  setIsModalUpdatable(false);
  clearErrorMessage();
};

const getFormValues = (connection: Connection) => {
  const connectionFormFields: ConnectionFormFields = {
    domain: connection.domain || '',
    clientId: connection.clientId || '',
    clientSecret: connection.clientSecret || '',
    useCommonEndpoint:
      connection.useCommonEndpoint !== undefined
        ? connection.useCommonEndpoint
        : true,
    strategy: connection.strategy || '',
  };

  return connectionFormFields;
};

const setFormValues = (values: ConnectionFormFields) => {
  setDomainInput(values.domain);
  setClientIdInput(values.clientId);
  setClientSecretInput(values.clientSecret);
  setUseCommonEndpointInput(values.useCommonEndpoint);
};

export const setIsLoadingSave = (isLoading: boolean) => {
  ConnectionsConfigureStore.isLoadingSave = isLoading;
};

export const setErrorMessage = (message: string) => {
  ConnectionsConfigureStore.errorMessage = message;
};

export const clearErrorMessage = () => {
  ConnectionsConfigureStore.errorMessage = null;
};
